import { Builder, Input } from '@builder.io/sdk';
import { PageHero } from './PageHero';
import { BuilderInputOptions } from '@/types/builder';
import { CONTENT_TYPES } from './PageHero.types';
import { getFilteredFormInputs } from '../LandingPageForm/LandingPageForm.registry';

const getFormInputs = () =>
  getFilteredFormInputs({
    excludedFields: ['heading', 'subHeading', 'useCardStyle'],
    defaultOverrides: {
      regLabel: 'Enter Registration Number',
      defaultDurationType: '2 days',
    },
    gateOnEnableForm: true,
  });

const ProductPageHeaderConfig = {
  name: 'PageHero',
  inputs: [
    {
      name: 'headingOnly',
      type: 'boolean',
      required: false,
      defaultValue: false,
      description: 'Display only the heading without any other content',
    },
    {
      name: 'title',
      type: 'string',
      required: true,
    },
    {
      name: 'subtitle',
      type: 'string',
      required: false,
      showIf: (options: BuilderInputOptions) => !options?.get('headingOnly'),
    },
    {
      name: 'tagline',
      type: 'richText',
      required: false,
      showIf: (options: BuilderInputOptions) => !options?.get('headingOnly'),
    },
    {
      name: 'enableForm',
      type: 'boolean',
      required: false,
      defaultValue: false,
      description: 'Enable form. This will hide the image.',
      showIf: (options: BuilderInputOptions) => !options?.get('headingOnly'),
    },
    ...getFormInputs(),
    {
      name: 'contentType',
      type: 'string',
      enum: Object.values(CONTENT_TYPES),
      defaultValue: CONTENT_TYPES.LIST,
      required: true,
      description: 'Content type to display',
      showIf: (options: BuilderInputOptions) => !options?.get('headingOnly'),
    },
    {
      name: 'points',
      type: 'list',
      required: false,
      showIf: (options: BuilderInputOptions) => options?.get('contentType') === 'List',
      description: 'List of points with tick icons to display',
      subFields: [
        {
          name: 'point',
          type: 'string',
        },
      ],
    },
    {
      name: 'body',
      type: 'richText',
      required: false,
      showIf: (options: BuilderInputOptions) =>
        options?.get('contentType') === 'Text' || options?.get('contentType') === 'Trustpilot',
      description: 'Text to display',
    },
    {
      name: 'image',
      type: 'file',
      required: false,
      showIf: (options: BuilderInputOptions) => !options?.get('enableForm'),
    },
    {
      name: 'imageFit',
      type: 'enum',
      enum: [
        { label: 'contain', value: 'contain' },
        { label: 'cover', value: 'cover' },
      ],
      required: false,
      defaultValue: 'cover',
      showIf: (options: BuilderInputOptions) => !options?.get('enableForm'),
    },
    {
      name: 'imagePosition',
      type: 'enum',
      enum: [
        { label: 'left', value: 'left' },
        { label: 'right', value: 'right' },
      ],
      required: false,
      defaultValue: 'right',
      showIf: (options: BuilderInputOptions) => !options?.get('enableForm'),
    },
    {
      name: 'showAppLinks',
      type: 'boolean',
      required: false,
      defaultValue: false,
      description: 'Show app store links',
      showIf: (options: BuilderInputOptions) => !options?.get('headingOnly'),
    },
    {
      name: 'appLinks',
      type: 'reference',
      model: 'store-links',
    },
  ] as Input[],
};

Builder.registerComponent(PageHero, ProductPageHeaderConfig);
